export default __webpack_public_path__ + "static/media/trr-drink-coffee-icedcoffee.c82d6a7b.png";